import { KeyboardArrowDownSharp, MenuOutlined } from "@mui/icons-material";
import { AppBar, Box, Drawer, Link, List, ListItem, ListItemText, Popover, Toolbar, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { theme } from "../../common/style/Theme";
import Menu from "../Menu";

const Navigation = (props) => {
    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null);
    const [expandedMenu, setExpandedMenu] = useState(null);
    
    // Media query to determine if we should show mobile/tablet layout
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
    
    const handleNavigation = (event, item) => {
        if(item.isMenu && isDesktop) {
            // Desktop popover menu logic
            setAnchorEl(
                {
                    x: event?.clientX,
                    y: event?.clientY,
                    menuItems: item.menuItems
                }
            )
        } else if (item.isMenu && !isDesktop) {
            // Mobile/tablet drawer menu expansion
            setExpandedMenu(expandedMenu === item.name ? null : item.name);
        } else {
            if(item.link === "/whym5") {
                navigate("/about")
                setTimeout(() => {
                    const section = document.getElementById("why-m5");
                    if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                    }
                }, 100);
            } else {
                // Regular navigation
                navigate(item.link);
                window.scroll({
                    top: 0,
                    behavior: 'smooth'
                })
            }
           
            setAnchorEl(null)
            props.setNavBg("transparent");
            props.setNavTextColor(theme.palette.common.white);
            setDrawerOpen(false);
            setExpandedMenu(null);
        }
    }

    useEffect(() => {
        if(anchorEl?.x && anchorEl?.y && anchorEl?.x > 0 && anchorEl?.y > 0) {
            props.setNavBg(theme.palette.common.white);
            props.setNavTextColor(theme.palette.text.primary);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [anchorEl, window.scrollY])

    return(
        <AppBar style={{
            boxShadow: "none",
            zIndex: 100,
            padding: isDesktop ? "5px 0" : "8px 0",
            backgroundColor: props.navBg,
            width: "100%",
            maxWidth: "100vw",
            overflowX: "hidden",
            // transition: "all 0.3s ease-in-out",
        }}>
            <Toolbar className="toolbar" style={{
                justifyContent: "space-between",
                backgroundColor: props.navBg,
                padding: isDesktop ? "0 24px" : "0 16px",
                minHeight: isDesktop ? "64px" : "56px",
                width: "100%",
                maxWidth: "100vw",
                boxSizing: "border-box",
            }}>
                {/* Left side - Menu button for mobile/tablet */}
                <Box style={{
                    display: isDesktop ? "none" : "flex",
                    alignItems: "center",
                }}>
                    <MenuOutlined sx={{
                        color: props.navTextColor || theme.palette.primary.main,
                        cursor: "pointer",
                        fontSize: "1.5rem"
                    }} onClick={() => setDrawerOpen(true)}/>
                </Box>

                {/* Logo/Title - Desktop: left aligned, Mobile: centered */}
                <Box style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: isDesktop ? "flex-start" : "center",
                    flex: isDesktop ? "none" : "1",
                    overflow: "hidden",
                }}>
                    {Boolean(props.title) && props.navBg === "transparent" &&
                    <Typography variant="h1" 
                        onClick={(event) => handleNavigation(event, {
                            name : props.mainName, 
                            link: props.mainLink
                        })} 
                        style={{
                            cursor: "pointer", 
                            color: props.navTextColor, 
                            textTransform: "uppercase",
                            fontWeight: 900,
                            fontSize: isDesktop ? "3rem" : "1.3rem",
                            letterSpacing: isDesktop ? "2px" : "1px",
                            padding: isDesktop ? "0 3vw" : "0",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: isDesktop ? "none" : "100%",
                        }}>
                        {props.title}
                    </Typography>}
                    {Boolean(props.logo) && props.navBg !== "transparent" &&
                        <img src={props.logo} alt="logo" style={{
                            width: isDesktop ? "5rem" : "2.5rem", 
                            height: isDesktop ? "5rem" : "2.5rem", 
                            objectFit: "contain", 
                            objectPosition: "center", 
                            cursor: "pointer",
                            flexShrink: 0,
                        }} 
                            onClick={(event) => handleNavigation(event, {
                                name: props.mainName, 
                                link: props.mainLink
                            })}
                        />
                    }
                </Box>

                {/* Desktop navigation */}
                <Box sx={{
                    display: isDesktop ? "flex" : "none", 
                    cursor: "pointer",
                }}>
                    {Boolean(props.navItems) && props.navItems.map((item, i) => (
                        <Link key={i}
                            style={{
                                color: props.navTextColor,
                                cursor: "pointer",
                                padding: "20px",
                                textDecoration: "none",
                                fontFamily: "'Montserrat', serif",
                                fontSize: "1rem",
                                fontWeight: 500,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                            onClick={(event) => handleNavigation(event, item)}
                        >
                                {item.name} {item.isMenu && <KeyboardArrowDownSharp style={{
                                    marginLeft: "5px",
                                    fontSize: "0.9rem",
                                }}/>}
                        </Link>
                    ))}
                </Box>
            </Toolbar>

            <Drawer 
                open={drawerOpen} 
                onClose={() => {
                    setDrawerOpen(false);
                    setExpandedMenu(null);
                }}
                anchor="left"
                sx={{
                    display: isDesktop ? "none" : "block",
                    "& .MuiDrawer-paper": {
                        width: "280px",
                        backgroundColor: theme.palette.common.white,
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                        overflowX: "hidden",
                    }
                }}
            >
                <Box style={{
                    padding: "20px",
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    marginBottom: "20px"
                }}>
                    {Boolean(props.logo) && (
                        <img src={props.logo} alt="logo" style={{
                            width: "3rem", 
                            height: "3rem", 
                            objectFit: "contain", 
                            objectPosition: "center"
                        }} />
                    )}
                    {Boolean(props.title) && !props.logo && (
                        <Typography variant="h6" style={{
                            color: theme.palette.primary.main,
                            fontWeight: 700,
                        }}>
                            {props.title}
                        </Typography>
                    )}
                </Box>
                <List style={{padding: "0 10px"}}>
                    {Boolean(props.navItems) && props.navItems.map((item, i) => (
                        <Box key={i}>
                            <ListItem 
                                style={{
                                    borderRadius: "8px",
                                    marginBottom: "5px",
                                    cursor: "pointer",
                                    padding: "12px 16px",
                                    transition: "background-color 0.2s ease",
                                }}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: theme.palette.primary.light + "20",
                                    }
                                }}
                                onClick={(event) => {
                                    handleNavigation(event, item);
                                }}
                            >
                                <ListItemText>
                                    <Typography style={{
                                        color: theme.palette.text.primary,
                                        fontWeight: 500,
                                        fontSize: "1rem",
                                        fontFamily: "'Montserrat', serif",
                                    }}>
                                        {item.name}
                                    </Typography>
                                </ListItemText>
                                {item.isMenu && (
                                    <KeyboardArrowDownSharp style={{
                                        color: theme.palette.text.secondary,
                                        fontSize: "1rem",
                                        transform: expandedMenu === item.name ? "rotate(180deg)" : "rotate(0deg)",
                                        transition: "transform 0.2s ease",
                                    }}/>
                                )}
                            </ListItem>
                            
                            {/* Submenu items */}
                            {item.isMenu && expandedMenu === item.name && item.menuItems && (
                                <Box style={{
                                    marginLeft: "20px",
                                    marginBottom: "10px",
                                    paddingLeft: "10px",
                                    borderLeft: `2px solid ${theme.palette.primary.light}`,
                                }}>
                                    {item.menuItems.map((subItem, subIndex) => (
                                        <Box key={subIndex}>
                                            {/* Menu Item */}
                                            <ListItem
                                                style={{
                                                    borderRadius: "6px",
                                                    marginBottom: "8px",
                                                    cursor: "pointer",
                                                    padding: "8px 12px",
                                                    transition: "background-color 0.2s ease",
                                                    backgroundColor: theme.palette.primary.light + "15",
                                                }}
                                                sx={{
                                                    "&:hover": {
                                                        backgroundColor: theme.palette.primary.light + "25",
                                                    }
                                                }}
                                                onClick={(event) => {
                                                    handleNavigation(event, subItem);
                                                }}
                                            >
                                                <ListItemText>
                                                    <Typography style={{
                                                        color: theme.palette.primary.main,
                                                        fontWeight: 600,
                                                        fontSize: "0.9rem",
                                                        fontFamily: "'Montserrat', serif",
                                                    }}>
                                                        {subItem.name}
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            
                                            {/* Menu Options under this Menu Item */}
                                            {subItem.menuOptions && (
                                                <Box style={{
                                                    marginLeft: "15px",
                                                    marginBottom: "10px",
                                                }}>
                                                    {subItem.menuOptions.map((option, optionIndex) => (
                                                        <ListItem
                                                            key={`option-${subIndex}-${optionIndex}`}
                                                            style={{
                                                                borderRadius: "4px",
                                                                marginBottom: "2px",
                                                                cursor: "pointer",
                                                                padding: "6px 12px",
                                                                transition: "background-color 0.2s ease",
                                                            }}
                                                            sx={{
                                                                "&:hover": {
                                                                    backgroundColor: theme.palette.primary.light + "10",
                                                                }
                                                            }}
                                                            onClick={(event) => {
                                                                handleNavigation(event, option);
                                                            }}
                                                        >
                                                            <ListItemText>
                                                                <Typography style={{
                                                                    color: theme.palette.text.secondary,
                                                                    fontWeight: 400,
                                                                    fontSize: "0.85rem",
                                                                    fontFamily: "'Montserrat', serif",
                                                                }}>
                                                                    {option.name}
                                                                </Typography>
                                                            </ListItemText>
                                                        </ListItem>
                                                    ))}
                                                </Box>
                                            )}
                                        </Box>
                                    ))}
                                </Box>
                            )}
                        </Box>
                    ))}
                </List>
            </Drawer>

            <Popover 
                open={Boolean(anchorEl?.x && anchorEl?.y) && isDesktop}
                anchorReference="anchorPosition"
                disableScrollLock={true}
                anchorPosition={{left: anchorEl?.x + 43, top: anchorEl?.y + 43}}
                onClose={() => {
                    setAnchorEl({
                        x: 0,
                        y:0,
                    })
                    setTimeout(() => {
                       props.setNavBg(window.scrollY < 20 ? "transparent" : theme.palette.common.white);
                        props.setNavTextColor(window.scrollY < 20 ? theme.palette.common.white : theme.palette.text.primary);
                    }, 80)
                }}
                sx={{
                    display: isDesktop ? "block" : "none",
                    top: `${46 - anchorEl?.y}px`,
                    left: "16px",
                    "& .MuiPaper-root": {
                        minWidth: "100vw",
                        maxWidth: "100vw",
                        minHeight: "45vh",
                        maxHeight: "auto",
                        borderRadius: 0,
                        boxShadow: "rgba(0, 0, 0, 0.45) 0px 25px 20px -20px",
                        transition: "background 0.3s ease-in",
                    }
                }}
            >
                <Menu 
                    anchor={anchorEl} 
                    setAnchor={setAnchorEl}
                    setNavBg={() => props.setNavBg("transparent")}
                    setNavTextColor={() => props.setNavTextColor(theme.palette.common.white)}
                />
            </Popover>
        </AppBar>
    )
}

export default Navigation;